<template>
  <el-dialog :visible.sync="show" :fullscreen="true" :show-close="false" custom-class="ccd" append-to-body>
    <div slot="title">
      组件配置<span v-if="component.componentId">&nbsp;:&nbsp;{{component.componentId}} - {{component.name}}</span>
      <el-button size="mini" icon="el-icon-upload" class="ccd-save" @click="toSave" type="primary">保 存</el-button>
      <el-button size="mini" icon="el-icon-circle-close" class="ccd-close" @click="show = false">退 出</el-button>
    </div>
    <design-area ref="designArea" :endpoint="endpoint" :uiId="uiId" :group="'index-' + group"></design-area>

    <el-dialog title="保存组件" :visible.sync="showForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="组件名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入组件名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请填写组件描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSave(false)">保 存</el-button>
        <el-button size="mini" type="primary" @click="doSave(true)">保存并退出</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import DesignArea from './DesignArea'

export default {
  name: 'component-config-dialog',
  components: {
    DesignArea
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true },
    group: { type: String, required: true }
  },
  data () {
    return {
      show: false,
      component: {},
      showForm: false,
      form: { name: '', desc: '' },
      formRule: {
        name: [{ required: true, message: '请输入组件名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open (component) {
      this.component = component || {}
      this.form = { name: this.component.name, desc: this.component.desc }
      this.show = true

      this.$nextTick(() => {
        if (this.component.componentId) {
          this.$http.request({
            method: 'get',
            url: `/api/cgComponents/${this.component.componentId}/config`
          }).then((res) => {
            this.$refs.designArea.init(res.data.data)
          })
        } else {
          this.$refs.designArea.init()
          if (this.$refs.form) {
            this.$refs.form.resetFields()
          }
        }
      })
    },
    toSave () {
      if (!this.$refs.designArea.hasConfig()) {
        this.$message.error('请先完成配置')
        return
      }
      this.showForm = true
    },
    doSave (exit) {
      let config = this.$refs.designArea.getConfig()
      if (!config) {
        this.$message.error('请先完成配置')
        return
      }

      this.$refs.form.validate((success) => {
        if (!success) {
          return false
        }

        let data = {
          uiId: this.uiId,
          type: this.group,
          name: this.form.name,
          config: JSON.stringify(config)
        }
        if (this.form.desc) {
          data.desc = this.form.desc
        }

        let componentId = this.component.componentId
        this.$http.request({
          method: !componentId ? 'post' : 'put',
          url: !componentId ? '/api/cgComponents' : `/api/cgComponents/${componentId}`,
          data: JSON.stringify(data)
        }).then(() => {
          this.showForm = false
          if (exit) {
            this.show = false
          }
          this.$emit('save')
        })
      })
    }
  }
}
</script>

<style lang='less'>
.ccd{
  .el-dialog__header{
    padding:15px 0;
    border-bottom:1px solid #ebeef5;
    >div{position:relative;text-align:center;height:28px;line-height:28px;}
  }
  .el-dialog__body{padding:0;}
}
.ccd-preview{position:absolute;top:0;left:10px;line-height:26px;padding:0 15px;}
.ccd-preview1{position:absolute;top:0;left:198px;line-height:26px;padding:0 15px;}
.ccd-save{position:absolute;top:0;right:96px;line-height:26px;padding:0 15px;}
.ccd-close{position:absolute;top:0;right:10px;line-height:26px;padding:0 15px;}
</style>
